import React from "react";
const LightEditIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    height="1em"
    width="1em"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5962 8.57037L7.70677 22.4598L2.92534 22.9887C1.53957 23.1421 0.360075 21.9732 0.513462 20.5768L1.04238 15.7954L14.9318 1.90598C16.143 0.694752 18.1 0.694752 19.306 1.90598L21.5909 4.19091C22.8021 5.40214 22.8021 7.36443 21.5962 8.57037ZM16.3705 10.2047L13.2975 7.13171L3.47012 16.9643L3.08401 20.4182L6.53786 20.0321L16.3705 10.2047ZM19.7979 5.98924L17.5129 3.70431C17.2961 3.48745 16.9417 3.48745 16.7301 3.70431L15.0958 5.33867L18.1688 8.41169L19.8032 6.77733C20.0147 6.55518 20.0147 6.2061 19.7979 5.98924Z"
      fill="white"
    />
  </svg>
);
export default LightEditIcon;
